import EnvironmentSettings from "../../Models/EnvironmentSettings";
import Swal from "sweetalert2";
import UsersApiOriginal from "../UsersApi";
import TenantManager from "../TenantManager";

class UsersApi {
  constructor() {
    EnvironmentSettings.Environment === "dev"
      ? (this.baseUrl = EnvironmentSettings.LocalUrl)
      : (this.baseUrl = EnvironmentSettings.LiveUrl);
  }

  // ************************ USERS **************************** */

  // users
  CreateUserUrl = "Users/CreateUser";
  EditUserUrl = "Users/EditUser";
  GetUserByIdUrl = "Users/GetUserById";
  GetUserByFirebaseIdUrl = "Users/GetUserByFirebaseId";
  SearchUsersUrl = "Users/SearchUsers";
  SoftDeleteUserUrl = "Users/SoftDeleteUser";
  ToggleUserActivationUrl = "Users/ToggleUserActivation";
  AssignTypeToUserUrl = "Users/AssignTypeToUser";
  ToggleSuperAdminUrl = "Users/ToggleSuperAdmin";
  IsSuperAdminUrl = "Users/IsSuperAdmin";

  async CreateUser(req) {
    const res = await fetch(this.baseUrl + this.CreateUserUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApiOriginal.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApiOriginal.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async EditUser(req) {
    const res = await fetch(this.baseUrl + this.EditUserUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApiOriginal.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApiOriginal.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async GetUserByFirebaseId(req) {
    const res = await fetch(this.baseUrl + this.GetUserByFirebaseIdUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApiOriginal.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApiOriginal.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async GetUserById(req) {
    const res = await fetch(this.baseUrl + this.GetUserByIdUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApiOriginal.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApiOriginal.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async ToggleUserActivation(req) {
    const res = await fetch(this.baseUrl + this.ToggleUserActivationUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApiOriginal.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApiOriginal.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async AssignTypeToUser(req) {
    const res = await fetch(this.baseUrl + this.AssignTypeToUserUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApiOriginal.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApiOriginal.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async SoftDeleteUser(req) {
    const res = await fetch(this.baseUrl + this.SoftDeleteUserUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApiOriginal.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApiOriginal.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });

    const data = await res.json();
    console.log(data);
    return data;
  }

  async SearchUsers(req) {
    const res = await fetch(this.baseUrl + this.SearchUsersUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${UsersApiOriginal.GetToken()}`,
        tenant: TenantManager.getTenant(UsersApiOriginal.GetToken()),
        "Content-type": "application/json",
      },
      body: JSON.stringify(req),
    });
    if (!res.ok) {
      Swal.fire({
        title: "Error",
        text: "Something went wrong while searching user!",
        icon: "error",
      });
    }
    const data = await res.json();
    console.log(data);
    return data;
  }
  async ToggleSuperAdmin(req) {
    try {
      const res = await fetch(`${this.baseUrl}Users/ToggleSuperAdmin`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${UsersApiOriginal.GetToken()}`,
          tenant: TenantManager.getTenant(UsersApiOriginal.GetToken()),
          "Content-type": "application/json",
        },
        body: JSON.stringify(req),
      });

      const data = await res.json();
      return data;
    } catch (error) {
      console.error("Error toggling Super Admin:", error);
      throw error;
    }
  }
  async IsSuperAdmin(firebaseId) {
    try {
      const response = await fetch(`${this.baseUrl}Users/IsSuperAdmin/${firebaseId}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${UsersApiOriginal.GetToken()}`,
          tenant: TenantManager.getTenant(UsersApiOriginal.GetToken()),
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Handle unauthorized (token expired)
          throw new Error("Session expired. Please log in again.");
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.isSuperAdmin; // Directly return the boolean
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  }
}

export default new UsersApi();
